module.exports = {
	"/es/": {
		"title": "Guerra a la mentira - Webdoc del Lab de RTVE.es y En Portada",
		"meta": [
			{
				"name": "description",
				"content": "Descubre qué es la verificación a través de fuentes abiertas en este webdoc que recrea el trabajo en defensa de los Derechos Humanos en conflictos armados."
			},
			{
				"name": "keywords",
				"content": "verificación, fuentes abiertas, geolocalización, mentiras guerra, descubrir mentiras de la guerra, informacion falsa guerras, posverdad, Derechos Humanos, webdoc, interactivo, fuentes anonimas, fuentes en redes sociales, informacion anonima, periodismo ciudadano"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-home.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "Guerra a la mentira - Webdoc del Lab de RTVE.es y En Portada"
			},
			{
				"property": "og:description",
				"content": "Descubre qué es la verificación a través de fuentes abiertas en este webdoc que recrea el trabajo en defensa de los Derechos Humanos en conflictos armados."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "Guerra a la Mentira - Descubre con este webdoc interactivo la verificación de fuentes abiertas"
	},
	"/en/": {
		"title": "War on Lying - RTVE.es Lab Webdoc and En Portada",
		"meta": [
			{
				"name": "description",
				"content": "Discover what the verification is through open sources in this webdoc, which recreates the work to defend Human Rights in armed conflicts."
			},
			{
				"name": "keywords",
				"content": "verification, open sources, geo-location, lies of war, discover war lies, false war information"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-home.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "War on Lying - RTVE.es Lab Webdoc and En Portada"
			},
			{
				"property": "og:description",
				"content": "Discover what the verification is through open sources in this webdoc, which recreates the work to defend Human Rights in armed conflicts."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Interactive webdoc about Open Sources Verification"
	},
	"/es/quien-bombardeo-hogar-omran/": {
		"title": "¿Quién bombardeó el hogar de Omran?  - Guerra a la mentira",
		"meta": [
			{
				"name": "description",
				"content": "En agosto de 2016, la imagen de un niño de cinco años llamado Omran se hizo viral tras sobrevivir a un bombardeo en Alepo, Siria. ¿Quién está detrás del ataque?"
			},
			{
				"name": "keywords",
				"content": "omran bombardeo, bombardeo alepo, quien bombardeó alepo, rusia bombardeo alepo, posverdad, rusia omran, guerra siria, siria, ataque a civiles, ataque aereo, cascos blancos, barrios rebeldes alepo, rebeldes sirios, bombardeo inocentes, ataques a inocentes siria, verificacion informacion, mentira, informacion falsa"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/quien-bombardeo-hogar-omran/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-omran.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "¿Quién bombardeó el hogar de Omran?  - Guerra a la mentira"
			},
			{
				"property": "og:description",
				"content": "En agosto de 2016, la imagen de un niño de cinco años llamado Omran se hizo viral tras sobrevivir a un bombardeo en Alepo, Siria. ¿Quién está detrás del ataque?"
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "¿Quién bombardeó el hogar de Omran? - Guerra a la Mentira | Descubre la verdad con este webdoc interactivo"
	},
	"/en/who-bombed-omran-home/": {
		"title": "Who bombarded Omran’s home? - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "In August 2016, the image of a five-year-old child called Omran went viral after surviving the Alepo bombardment. Who is behind the attack?"
			},
			{
				"name": "keywords",
				"content": "Omran Bombardment, Alepo bombardment, who bombarded Alepo, Alepo bombardment Russia, Omran Russia"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/quien-bombardeo-hogar-omran/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-omran.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "Who bombarded Omran’s home? - War on Lying"
			},
			{
				"property": "og:description",
				"content": "In August 2016, the image of a five-year-old child called Omran went viral after surviving the Alepo bombardment. Who is behind the attack?"
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Who bombarded Omran’s home?"
	},
	"/es/quien-derribo-mh17/": {
		"title": "¿Quién derribó el MH17 Malasian Airlines? - Guerra a la mentira",
		"meta": [
			{
				"name": "description",
				"content": "¿Sabes quién es el el responsable del derribo del MH17? Recrea el proceso de búsqueda de información y verificación de Bellingcat para descubrir la verdad."
			},
			{
				"name": "keywords",
				"content": "derribo malaysia airlines, mh17 derribo, ucrania, quien derribo mh17, rusia derribo avion malasia airlines, rusia mh17, ucrania mh17, malaysia airlines, misil buk, muertes civiles, euromaidan, guerra civil ucrania, rebeldes ucranianos, donetsk, verificacion, fuentes abiertas"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/quien-derribo-mh17/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-derribo-mh17.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "¿Quién derribó el MH17 Malasian Airlines? - Guerra a la mentira"
			},
			{
				"property": "og:description",
				"content": "¿Sabes quién es el el responsable del derribo del MH17? Recrea el proceso de búsqueda de información y verificación de Bellingcat para descubrir la verdad."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "¿Quién derribó el MH17? - Guerra a la Mentira | Descubre la verdad con este webdoc interactivo"
	},
	"/en/who-downed-mh17/": {
		"title": "Who shot down the Malaysian Airlines MH17 aircraft? - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "Do you know who was responsible for shooting down the MH17? This was Bellingcat’s verification process to discover the truth."
			},
			{
				"name": "keywords",
				"content": "shooting down Malaysian Airlines, mh17 shot down, who shot down mh17, Russia shot down Malaysian plane, Russian mh17, Ukraine mh17"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/quien-derribo-mh17"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-derribo-mh17.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "Who shot down the Malaysian Airlines MH17 aircraft? - War on Lying"
			},
			{
				"property": "og:description",
				"content": "Do you know who was responsible for shooting down the MH17? This was Bellingcat’s verification process to discover the truth."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Who knocked down the MH17?"
	},
	"/es/quien-destruyo-convoy-humanitario/": {
		"title": "Bombardeo a un convoy humanitario a las afueras de Alepo, ¿Rusia? - Guerra a la mentira",
		"meta": [
			{
				"name": "description",
				"content": "Un ataque contra un convoy de ayuda humanitaria en Alepo en septiembre de 2016 acabó con la vida de 20 personas. ¿Pero quién atacó este convoy?"
			},
			{
				"name": "keywords",
				"content": "bombardeo convoy humanitario, bombardeo convoy alepo, convoy humanitario alepo"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/quien-destruyo-convoy-humanitario/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-destruyo-convoy-humanitario.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "Bombardeo a un convoy humanitario a las afueras de Alepo, ¿Rusia? - Guerra a la mentira"
			},
			{
				"property": "og:description",
				"content": "Un ataque contra un convoy de ayuda humanitaria en Alepo en septiembre de 2016 acabó con la vida de 20 personas. ¿Pero quién atacó este convoy?"
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "¿Quién atacó el convoy de ayuda humaniraria de la Cruz Roja y ONU? | Descubre la verdad con este webdoc interactivo"
	},
	"/en/who-destroyed-the-humanitarian-convoy/": {
		"title": "Bombardment of a humanitarian convey on the outskirts of Alepo, Russia? - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "An attack against a humanitarian aid convoy in Alepo in September 2016 killed 20 people. But who attacked this convoy?"
			},
			{
				"name": "keywords",
				"content": "humanitarian convoy bombardment, Alepo convoy bombardment, Alepo humanitarian convoy"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/quien-destruyo-convoy-humanitario"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-destruyo-convoy-humanitario.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "Bombardment of a humanitarian convey on the outskirts of Alepo, Russia? - War on Lying"
			},
			{
				"property": "og:description",
				"content": "An attack against a humanitarian aid convoy in Alepo in September 2016 killed 20 people. But who attacked this convoy?"
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Who attacked the humanitarian convoy?"
	},
	"/es/documental/": {
		"title": "Guerra a la mentira - Reportaje de En Portada",
		"meta": [
			{
				"name": "description",
				"content": "Descubre en este reportaje el movimiento ciudadano que busca comprobar mediante fuentes abiertas la verdad sobre crímenes de todo el mundo."
			},
			{
				"name": "keywords",
				"content": "reportaje, en portada, bellingcat, first draft, international amnisty, Eliott Higgins, Alistar Reid, OSINT, fake news, digital information, forensic architecture, The Guardian, eyewitness to atrocities"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/documental/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-documental.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "Guerra a la mentira - Reportaje de En Portada"
			},
			{
				"property": "og:description",
				"content": "Descubre en este reportaje el movimiento ciudadano que busca comprobar mediante fuentes abiertas la verdad sobre crímenes de todo el mundo."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "Guerra a la Mentira- Reportaje de @enportada_tve sobre la investigación mediante fuentes abiertas"
	},
	"/en/documentary/": {
		"title": "War on lying - En Portada documentary",
		"meta": [
			{
				"name": "description",
				"content": "Discover the citizen movement that use open sources to find the truth about crimes around the world."
			},
			{
				"name": "keywords",
				"content": "documentary, en portada, bellingcat, first draft, international amnisty, Eliott Higgins, Alistar Reid, OSINT, fake news, digital information, forensic architecture, The Guardian, eyewitness to atrocities"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/documental/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-documental.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "War on lying - En Portada documentary"
			},
			{
				"property": "og:description",
				"content": "Discover the citizen movement that use open sources to find the truth about crimes around the world."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - @enportada_tve Documentary about open sources investigations"
	},
	"/es/tutoriales/": {
		"title": "Tutoriales y casos de referencia  - Guerra a la mentira",
		"meta": [
			{
				"name": "description",
				"content": "Descubre los casos más relevantes de verificación de fuentes abiertas, e investiga tutoriales de certificación para convertirte en un experto."
			},
			{
				"name": "keywords",
				"content": "verificacion fuentes abiertas, descubrir verdad, tutoriales verificacion, casos relevantes verificacion fuentes abiertas, guta, Ghouta, siria, Maiduguri, Nigeria,Yemen, Saynaya, amnistia internacional, human rights watch, Rafah, Viernes negro, palestina, Forensic Architecture, First Draft, Citizen Evidence Lab, Cascos blancos, White Helmets, Bomba de barril, Corredor humanitario, Alto el fuego, gas clorhídrico, Euromaidan, BUK, Verificación de imágenes, Desafío de Observación, Verificación con Google Earth, Geolocalización, Geoguessr, Evaluación de vídeo, busqueda informacion redes sociales"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/tutoriales/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-tutoriales.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "Tutoriales y casos de referencia  - Guerra a la mentira"
			},
			{
				"property": "og:description",
				"content": "Descubre los casos más relevantes de verificación de fuentes abiertas, e investiga tutoriales de certificación para convertirte en un experto."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "Conviértete en un experto en verificación de fuentes abiertas con el webdoc interactivo Guerra a la Mentira"
	},
	"/en/tutorials/": {
		"title": "Tutorials and reference cases - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "Discover the most relevant open source verification cases, and research certification tutorials to become an expert."
			},
			{
				"name": "keywords",
				"content": "open sources verification, tutorials, Ghouta, siria, Maiduguri, Nigeria,Yemen, Saynaya, International Amnisty, human rights watch, Rafah, Viernes negro, palestina, Forensic Architecture, First Draft, Citizen Evidence Lab, White Helmets"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/tutorials/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-tutoriales.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "Tutorials and reference cases - War on Lying"
			},
			{
				"property": "og:description",
				"content": "Discover the most relevant open source verification cases, and research certification tutorials to become an expert."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Find resources to become an expert on open sources"
	},
	"/es/quien-hace-estas-verificaciones/": {
		"title": "De Eliot Higgins a Amnistía Internacional - Guerra a la Mentira",
		"meta": [
			{
				"name": "description",
				"content": "Descubre quiénes trabajan con fuentes abiertas en el proceso de verificación en defensa de los Derechos Humanos."
			},
			{
				"name": "keywords",
				"content": "periodistas guerras, periodistas mentiras guerra, mentiras de la guerra quien, periodismo ciudadano, fuentes abiertas, testigos, verificacion fuentes abiertas, Derechos Humanos, crimenes de guerra, bellingcat, first draft, amnistia internacional, justicia internacional"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/quien-hace-estas-verificaciones/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-hace-estas-verificaciones.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "De Eliot Higgins a Amnistía Internacional - Guerra a la Mentira"
			},
			{
				"property": "og:description",
				"content": "Descubre quiénes trabajan con fuentes abiertas en el proceso de verificación en defensa de los Derechos Humanos."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "La verificación de fuentes abiertos es un proceso de búsqueda de la verdad realizado por ciudadanos como tú | Descúbrelo en Guerra a la Mentira"
	},
	"/en/who-verified-internationtal-wars/": {
		"title": "From Eliot Higgins to Amnesty International - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "Discover who works with open sources in the verification process to defend Human Rights."
			},
			{
				"name": "keywords",
				"content": "wars journalists, lies of war journalists, lies of war who"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/quien-hace-estas-verificaciones/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-quien-hace-estas-verificaciones.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "From Eliot Higgins to Amnesty International - War on Lying"
			},
			{
				"property": "og:description",
				"content": "Discover who works with open sources in the verification process to defend Human Rights."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Open Sources verification is within everyone's reach. Find out!"
	},
	"/es/creditos/": {
		"title": "Créditos - Guerra a la Mentira",
		"meta": [
			{
				"name": "description",
				"content": "Créditos del webdoc interactivo Guerra a la Mentira. Descubre qué es la verificación a través de fuentes abiertas en este webdoc que recrea el trabajo en defensa de los Derechos Humanos en conflictos armados."
			},
			{
				"name": "keywords",
				"content": "Guión, coordinación, dirección, imagen y sonido, realización, diseño gráfico, desarrollo, Guión César Peña, Realización Marcos Martín, Desarrollo Lab RTVE.es, Diseño Lab RTVE.es, Coordinación Miriam Hernanz"
			},
			{
				"name": "author",
				"content": "Laboratorio Rtve.es"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/es/creditos/"
			},
			{
				"property": "og:site_name",
				"content": "Guerra a la mentira - Laboratorio Rtve.es"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-home.png"
			},
			{
				"property": "og:locale",
				"content": "es_ES"
			},
			{
				"property": "og:title",
				"content": "Créditos - Guerra a la Mentira"
			},
			{
				"property": "og:description",
				"content": "Créditos del webdoc interactivo Guerra a la Mentira."
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "Guerra a la Mentira - Descubre con este webdoc interactivo la verificación de fuentes abiertas"
	},
	"/en/credits/": {
		"title": "Credits - War on Lying",
		"meta": [
			{
				"name": "description",
				"content": "Interactive Webdoc War on Lying credits. Discover what the verification is through open sources in this webdoc, which recreates the work to defend Human Rights in armed conflicts."
			},
			{
				"name": "keywords",
				"content": "Script, Direction, Images, Sound, Assembly, Production, Soundtrack, Background music, Graphic art, Script César Peña, director Marcos Martín, Camera & Sound José Martínez, Alfredo Sánchez-Toledo, development Lab RTVE.es, desing Lab RTVE.es, Editor Marga Serrano, Script Yolanda Álvarez"
			},
			{
				"name": "author",
				"content": "RTVE.es Lab"
			},
			{
				"charset": "utf-8"
			},
			{
				"property": "og:url",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/en/credits/"
			},
			{
				"property": "og:site_name",
				"content": "War on Lying - RTVE.es Lab"
			},
			{
				"property": "og:image",
				"content": "https://lab.rtve.es/webdocs/guerra-mentira/media/image/share-home.png"
			},
			{
				"property": "og:locale",
				"content": "en_US"
			},
			{
				"property": "og:title",
				"content": "Credits - War on Lying"
			},
			{
				"property": "og:description",
				"content": "Interactive Webdoc credits"
			},
			{
				"property": "og:image:width",
				"content": "1200"
			},
			{
				"property": "og:image:height",
				"content": "630"
			}
		],
		"twitterText": "War on lying - Interactive webdoc about Open Sources Verification"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 628
// module chunks = 0